import { Revision } from '../../services/models/Revision'

export const buildRevision = (revision: any) => {
    let rev: Revision = revision
    return rev
}

export const buildRevisionList = (miniApp: any) => {
    let revisionList = miniApp && miniApp.revisions ? miniApp.revisions.map((revision: Revision) => revision) : []
    return revisionList
}

export const initializeRevision = (userEmail: any) => {
    let revision: Revision = {
        version: '',
        url: '',
        latest: true,
        reviewer: userEmail,
        createdBy: userEmail,
        status: 'IN_DRAFT',
        createdAt: new Date(),
        updateAt: new Date(),
        approvals: [],
    }
    return revision
}
